import React from "react";

import { ShellLink } from "@/src/components";

import { cn } from "utils";
import { AgentIdEnum } from "../Find/const";
import { getAgentIcon } from "./agenTypeUtils";

interface AgentItemProps {
  type?: "home" | "history";
  sourceType: AgentIdEnum;
  content: string;
  path: string;
  onClick?: (path: string) => void;
  isSelected?: boolean;
  style?: React.CSSProperties;
}

const AgentItem = ({
  sourceType,
  content,
  path,
  onClick,
  isSelected,
  style,
}: AgentItemProps) => {
  const Icon = getAgentIcon(sourceType);
  return (
    <ShellLink
      aria-label="Agent Item"
      data-openreplay-label={`Agent Item Link | ${path}`}
      id="lnk-agent-item"
      href={path}
      className={cn(
        "flex flex-row items-center h-10 p-2 md:hover:bg-background_solid_tertiary gap-2 rounded-lg md:group",
        {
          "bg-background_solid_tertiary": isSelected,
        },
      )}
      onClick={() => onClick?.(path)}
      style={style}
    >
      {Icon}
      <span
        className={cn(
          "md:group-hover:text-content_primary body_m text-ellipsis overflow-hidden whitespace-nowrap text-content_tertiary",
          {
            "text-content_primary": isSelected,
          },
        )}
      >
        {content}
      </span>
    </ShellLink>
  );
};

export default React.memo(AgentItem);
